// extracted by mini-css-extract-plugin
module.exports = {"item":"constructor-item_item__2Jy72"};